import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import type { DividerProps } from './Layout.types';

export const Divider = forwardRef<HTMLHRElement, DividerProps>(
  (
    { className, orientation = 'horizontal', decorative = true, ...props },
    ref,
  ) => {
    return (
      <hr
        ref={ref}
        role={decorative ? 'presentation' : 'separator'}
        aria-orientation={!decorative ? orientation : undefined}
        className={cn(
          'shrink-0 border-neutral-200 dark:border-neutral-700',
          orientation === 'horizontal'
            ? 'h-px w-full border-t'
            : 'h-full w-px border-l',
          className,
        )}
        {...props}
      />
    );
  },
);

Divider.displayName = 'Divider';
